import { IUsers, IUsersItems, UsersReponseType, UserAddRequestType } from '@/entity/Settings/Users.types';
import { ResponseDataType } from '@/form/form.types';
import Api from '@/repository/api';
import { ISettingsUsersRepository } from '@/repository/Settings/Users/SettingsUserRepository.types';
import { Users } from '@/entity/Settings/Users';
import { PaginationRequestType } from '@/entity/common/pagination.types';
import { getResponse, getResponseQs } from '@/repository/Helpers/repositoryLib';

export class SettingsUserRepository implements ISettingsUsersRepository {
    async fetchAll(data?: FormData): Promise<IUsers> {
        console.log('SettingsUserRepository fetchAll');
        const response = await getResponse(`/user/get`, data);
        const responseData = response.data as UsersReponseType;
        return new Users(responseData);
    }
    async fetchData(data: PaginationRequestType): Promise<IUsersItems> {
        const response = await getResponseQs(`/user/get`, data);
        const responseData = response.data as UsersReponseType;
        return new Users(responseData).data[0];
    }
    async create(data: UserAddRequestType): Promise<ResponseDataType> {
        const res = await Api.post('/user/registrate', data);
        return res.data;
    }
    async update(data: UserAddRequestType): Promise<ResponseDataType> {
        const res = await Api.post('/user/update', data);
        return res.data;
    }
    async delete(data: {id: number | null}): Promise<ResponseDataType> {
        const res = await Api.post('/user/delete', data)
        const response = res.data
        return response
    }
}
